const getImageBySize = (url, size) =>
  url ? url.replace('{{size}}', size) : '';

export default getImageBySize;
